import { Component } from '@angular/core';
import { SettingsPageService } from '../service/SettingsPage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css']
})
export class SettingsPageComponent {

  selectedTabIndex: number = 0;

  constructor( private settingsService: SettingsPageService) {

  }

  ngOnInit() {
    this.selectedTabIndex = this.settingsService.getSelectedTab();
  }

  onTabChange(tab: any): void {
    this.selectedTabIndex = tab.index;
    this.settingsService.setSelectedTab(tab.index);
  }

}
